import React, { useEffect, useState, useContext, useRef } from 'react';
import * as S from './styles_Repres';
import { Context } from '../../services/contexts/StateContext';
// -----------------------

import { PesquisaPadrao } from '../Pesquisas/PesquisaPadrao';
import { ListaItemBD } from '../ListarPesquisas/listaItemBD';
import { Functions } from '../Functions';
import { API_Franquia } from '../../services/FiltrosApi/franquiaApi';

// ----------------------------------------

export function Validar_Representante({cpfValidado, setCpfValidado, Play_Modal_Add, setShowModalAddFranquia}) {
    const { state, dispatch } = useContext(Context);
    const { veiculo } = state.veiculo;
    const { franquia } = state.franquia;
    const { parametroInit, playmodal, listaPesquisa } = state.parametros;
    const { editModal } = parametroInit;

    const { PesqFranquia} = API_Franquia();
    const { EditarSelect } = Functions();
    
    // ----------------------

    // Estados para validação de CPF
    const [digitosCpf, setDigitosCpf] = useState('');
    const [erroCpf, setErroCpf] = useState('');
    const [sucessoCpf, setSucessoCpf] = useState(false);

    // Verificar validação salva no localStorage ao carregar representante
    useEffect(() => {
        if (franquia.id) {
            // Verificar se existe validação salva no localStorage
            const validacaoSalva = localStorage.getItem(`cpf_validado`);
            
            if (validacaoSalva) {
                try {
                    const { timestamp, validado } = JSON.parse(validacaoSalva);
                    const agora = new Date().getTime();
                    const tempoDecorrido = agora - timestamp;
                    const vintequatroHoras = 24 * 60 * 60 * 1000; // 24 horas em milissegundos

                    // Se ainda está dentro das 24h, usar validação salva
                    if (tempoDecorrido < vintequatroHoras && validado) {
                        console.log('✅ Validação de CPF encontrada no localStorage (válida por 24h)');
                        setCpfValidado(true);
                        setSucessoCpf(true);
                        setErroCpf('');
                        setDigitosCpf('****'); // Mostrar que já foi validado
                    } else {
                        // Validação expirada, limpar localStorage
                        console.log('⏰ Validação de CPF expirada (mais de 24h)');
                        localStorage.removeItem(`cpf_validado`);
                        setCpfValidado(false);
                        setDigitosCpf('');
                        setErroCpf('');
                        setSucessoCpf(false);
                    }
                } catch (error) {
                    console.error('Erro ao ler validação do localStorage:', error);
                    setCpfValidado(false);
                    setDigitosCpf('');
                    setErroCpf('');
                    setSucessoCpf(false);
                }
            } else {
                // Não há validação salva, resetar
                console.log("erro 2")
                setCpfValidado(false);
                setDigitosCpf('');
                setErroCpf('');
                setSucessoCpf(false);
            }
        }
    }, [franquia.id]);
    
    // ------------------------------

    // Função para validar os 4 primeiros dígitos do CPF
    const validarCpf = () => {
        setErroCpf('');
        setSucessoCpf(false);

        if (!digitosCpf || digitosCpf.length !== 4) {
            setErroCpf('Por favor, digite os 4 primeiros dígitos do CPF.');
            return;
        }

        const cpfLimpo = franquia.cpfCnpj?.replace(/\D/g, '');
        const primeirosDígitos = cpfLimpo?.substring(0, 4);

        if (digitosCpf === primeirosDígitos) {
            setCpfValidado(true);
            setSucessoCpf(true);
            setErroCpf('');

            // Salvar validação no localStorage com timestamp
            const validacaoData = {
                validado: true,
                timestamp: new Date().getTime(),
                franquiaId: franquia.id,
                nome: franquia.nome,
            };
            
            localStorage.setItem(`cpf_validado`, JSON.stringify(validacaoData));
            console.log('💾 Validação de CPF salva no localStorage (válida por 24h)');
        } else {
            setErroCpf('CPF incorreto. Tente novamente.');
            console.log("erro de validação de CPF");
            setCpfValidado(false);
        }
    };
    // -----------------

    useEffect(() => {
        if (digitosCpf.length === 4 && !cpfValidado){
            validarCpf();
        }
    }, [digitosCpf]);

    

    // ----Abrir Novo----------
    function InputFranquia() {
        setShowModalAddFranquia(true);

        dispatch({
            type: 'set_ListaPesquisa',
            payload: {
                ...listaPesquisa,
                nomeItem: "",
                selectItem: '',
                alertaNovo: false
            }
        });
    };
    // -------------

    useEffect(() => {
      if(!veiculo.tipo && franquia.id){
        alert("Veiculo sem tipo informado");

        dispatch({
            type: 'SET_PLAYMODAL',
            payload: {
                ...playmodal,
                playModalEvenPlaca: true,
            }
        });
      }
    }, [veiculo.id_Veiculo])
    // ------------------------

    // -----------------------

    useEffect(() => {
      if(listaPesquisa.nomeItem && listaPesquisa.listaFranquia.length === 0){
            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    alertaNovo: true,
                }
            });
        }
    }, [listaPesquisa.listaFranquia])
    // -----------------------

    useEffect(() => {
      if (listaPesquisa.nomeItem.length === 0){
            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    listaFranquia: [],
                }
            });
        };
    }, [listaPesquisa.nomeItem])

    //###################################################################################
    return (
        <S.body
            detalhesLista={parametroInit.detalhesLista}
            editModal={editModal}
        >
            <S.Container>
                { /* ---------Representante----------- */
                !franquia.id &&
                <>
                <S.divPesq>
                    <PesquisaPadrao
                        refNomeCPF={true}
                        playTudo={false}
                        titulo="Buscar Representante"
                        placeholder="nome"
                        playModal_Add={Play_Modal_Add}
                        Pesquisar={PesqFranquia}
                        PesqDentroModal={true}
                        playBotao={false}
                        Lupa={true}
                    />
                </S.divPesq>

                {
                // listaPesquisa.nomeItem &&
                <S.divListaVistoria>
                    <ListaItemBD
                    Cadastro={true}
                    listaItem={listaPesquisa.listaFranquia}
                    NovoCadastro={InputFranquia}
                    referenciaRef="RefFranquia"
                    />
                </S.divListaVistoria>
                }
                </>}

                { //------------------------------
                franquia.id &&
                <S.div3 style={{alignItems:"center"}} >  
                    <S.box1>
                        <div style={{ display: "flex", width: "98%", justifyContent: "space-between", marginTop: "5px" }}>
                            <div className='listaFlexCol'>
                                <span className='titulo'> Representante: </span>
                                <span
                                    className='tituloHover'
                                    style={{ cursor: "pointer", textTransform: "uppercase", width:"95%", overflow:"hidden" }}
                                    onClick={() => EditarSelect("RefFranquia")}
                                >
                                    {franquia.nome}
                                </span>
                            </div>

                            <div className='listaFlexCol'>
                                <span className='titulo'>Cidade: </span>
                                <span style={{ textTransform: "uppercase", color: "white" }}>
                                    {franquia.cidade}
                                </span>
                            </div>
                        </div>
                    </S.box1>
                </S.div3>
                }
                
                {/* ---------VALIDAÇÃO DE CPF---------- */
                franquia.id && !cpfValidado && !veiculo.id_Veiculo && !editModal && digitosCpf !== '****' && 
                (
                    <S.validar>
                        <div 
                        style={{ 
                            display: 'flex',
                            backgroundColor: '#1a1a2e', 
                            border: '1px solid #FFD700', 
                            padding: '20px',
                            borderRadius: '8px',
                            marginTop: '10px',
                            width: '85%'
                        }}>
                            <div style={{ 
                                display: 'flex', 
                                flexDirection: 'column', 
                                alignItems: 'center', 
                                width: '100%'
                            }}>

                                <div
                                style={{ 
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    width: '100%',
                                }}>
                                    <span style={{ color: '#FFD700', marginBottom: '5px', fontSize: 'clamp(11px, 3vw, 14px)', textAlign: 'center' }}>
                                        🔒 4 Primeiros Dígitos do CPF do Representante:
                                    </span>

                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <input
                                        autoFocus
                                        value={digitosCpf}
                                        type='text'
                                        placeholder='0000'
                                        maxLength={4}
                                        style={{
                                            display: 'flex',
                                            fontSize: '20px',
                                            textAlign: 'center',
                                            letterSpacing: '5px',
                                            fontWeight: 'bold',
                                            padding: '12px',
                                            maxWidth:"200px",
                                            width: '65%',
                                        }}
                                        onChange={(e) => {
                                            const valor = e.target.value.replace(/\D/g, '');
                                            setDigitosCpf(valor);
                                            setErroCpf('');
                                        }}
                                        />
                                    </div>
                                </div>

                                {erroCpf && (
                                    <div style={{ 
                                        color: '#ff4444', 
                                        fontSize: 'clamp(12px, 2vw, 14px)',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        backgroundColor: 'rgba(255, 68, 68, 0.1)',
                                        padding: '10px 0',
                                        borderRadius: '4px',
                                        width: '100%'
                                    }}>
                                        ❌ {erroCpf}
                                    </div>
                                )}

                                {sucessoCpf && (
                                    <div style={{ 
                                        color: '#00ff00', 
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        backgroundColor: 'rgba(0, 255, 0, 0.1)',
                                        padding: '10px',
                                        borderRadius: '4px',
                                        width: '100%'
                                    }}>
                                        ✓ CPF validado com sucesso!
                                    </div>
                                )}
                            </div>
                        </div>
                    </S.validar>
                 )} 
            </S.Container>
        </S.body>
    );
}
